import { NO_OP } from "@thi.ng/api";
import { reduce, reducer } from "../reduce";
export function last(xs) {
    return xs ? reduce(last(), xs) : reducer(NO_OP, (_, x) => x);
}
